import React from 'react'
import { EmptyState, LoadingState } from '../../../../../../shared/empty-state/empty-state'

// The body of a Content / Templates / Library card grid: skeleton rows until
// the first fetch answers, the page's zero state when this level has nothing
// in it, and the cards otherwise.
export const NodeGridBody = ({ loaded, isEmpty, emptyState, children }) => {
  if (!loaded) return <LoadingState />
  if (isEmpty) return <EmptyState {...emptyState} />
  return children
}
